import React from 'react';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import isEmpty from 'lodash/isEmpty';
import {FormErrors} from '../common';
import ProfileForm from './ProfileForm';
import {updateProfile} from 'actions/account';
import {addFlashMessage} from 'actions/flash-message';
import {formatErrors} from 'actions/errors';
import {fetchAllCommonImages} from 'api/images';

class UserUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      activeUserAvatars: null,
    };
    this.fetchReaderAvatars = this.fetchReaderAvatars.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentDidMount() {
    this.fetchReaderAvatars();
  }

  fetchReaderAvatars() {
    const {
      user: {role, level},
    } = this.props;
    if (role === 'reader') {
      fetchAllCommonImages({type: 'user-avatar', level}).then(({records}) => {
        this.setState({activeUserAvatars: records.filter(({active}) => active)});
      });
    }
  }

  handleFormSubmit(data) {
    const {updateProfile, formatErrors, addFlashMessage} = this.props;
    return updateProfile(data)
      .then(() => addFlashMessage('User has been successfully updated!', 'success'))
      .catch((err) =>
        formatErrors(err).then((err) => {
          this.setState({
            errors: err,
          });
        }),
      );
  }

  render() {
    const {errors, activeUserAvatars} = this.state;
    const {
      user: {role},
    } = this.props;
    if (role === 'reader' && isEmpty(activeUserAvatars)) return null;
    return (
      <div className="container content-box">
        <Panel>
          <h3 className="section-header">
            <div className="section-title">Account Profile</div>
          </h3>
          <FormErrors errors={errors} />
          <ProfileForm onSubmit={this.handleFormSubmit} activeUserAvatars={activeUserAvatars} isUpdate />
        </Panel>
      </div>
    );
  }
}

const mapStateToProps = ({account}) => {
  const user = account.get('user').toJS();
  return {
    user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  formatErrors: (...args) => dispatch(formatErrors(...args)),
  addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
  updateProfile: (...args) => dispatch(updateProfile(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserUpdate);
